export function isEmpty(obj) {
  return (
    obj == null || (Object.keys(obj).length === 0 && obj.constructor === Object)
  );
}
